const sizeChartData = [
  {
    title: 'Mens Shirts',
    eventKey: 'men',
    tables: [
      {
        header: ['Sizes', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
        rows: [
          {
            label: 'Width',
            values: [
              {
                cm: 46,
                inch: 18,
              },
              {
                cm: 51,
                inch: 20,
              },
              {
                cm: 56,
                inch: 22,
              },
              {
                cm: 61,
                inch: 24,
              },
              {
                cm: 66,
                inch: 26,
              },
              {
                cm: 71,
                inch: 28,
              },
            ],
          },
          {
            label: 'Length',
            values: [
              {
                cm: 71,
                inch: 28,
              },
              {
                cm: 74,
                inch: 29,
              },
              {
                cm: 77,
                inch: 30,
              },
              {
                cm: 79,
                inch: 31,
              },
              {
                cm: 83,
                inch: 32.5,
              },
              {
                cm: 85,
                inch: 33.5,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Women Shirts',
    eventKey: 'women',
    tables: [
      {
        header: ['Sizes', 'S', 'M', 'L', 'XL', 'XXL'],
        rows: [
          {
            label: 'Width',
            values: [
              {
                cm: 41,
                inch: 16,
              },
              {
                cm: 43,
                inch: 17,
              },
              {
                cm: 47,
                inch: 18.5,
              },
              {
                cm: 50,
                inch: 19.5,
              },
              {
                cm: 56,
                inch: 22,
              },
            ],
          },
          {
            label: 'Length',
            values: [
              {
                cm: 64,
                inch: 25,
              },
              {
                cm: 67,
                inch: 26,
              },
              {
                cm: 69,
                inch: 27,
              },
              {
                cm: 71,
                inch: 28,
              },
              {
                cm: 72,
                inch: 28.5,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Kids Shirts',
    eventKey: 'kids',
    tables: [
      {
        header: ['Sizes', 'M', 'L', 'XL'],
        rows: [
          {
            label: 'Width',
            values: [
              {
                cm: 41,
                inch: 16,
              },
              {
                cm: 44,
                inch: 17,
              },
              {
                cm: 47,
                inch: 18,
              },
            ],
          },
          {
            label: 'Length',
            values: [
              {
                cm: 52,
                inch: 20,
              },
              {
                cm: 56,
                inch: 22,
              },
              {
                cm: 60,
                inch: 24,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Hoodies/Sweaters',
    eventKey: 'hoodies-sweaters',
    tables: [
      {
        header: ['Sizes', 'S', 'M', 'L', 'XL', 'XXL'],
        rows: [
          {
            label: 'Chest Size',
            values: [
              {
                cm: '92-101',
                inch: '36-40',
              },
              {
                cm: '102-112',
                inch: '40-44',
              },
              {
                cm: '112-117',
                inch: '44-46',
              },
              {
                cm: '117-122',
                inch: '46-48',
              },
              {
                cm: '117-122',
                inch: '50-52',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Tank Tops',
    eventKey: 'tank-tops',
    tables: [
      {
        header: ['Mens Sizes', 'S', 'M', 'L', 'XL', 'XXL'],
        rows: [
          {
            label: 'Chest Size',
            values: [
              {
                cm: 46,
                inch: 18,
              },
              {
                cm: 51,
                inch: 20,
              },
              {
                cm: 56,
                inch: 22,
              },
              {
                cm: 61,
                inch: 24,
              },
              {
                cm: 66,
                inch: 26,
              },
            ],
          },
          {
            label: 'Length',
            values: [
              {
                cm: 70,
                inch: 28,
              },
              {
                cm: 73,
                inch: 29,
              },
              {
                cm: 75.5,
                inch: 30,
              },
              {
                cm: 78,
                inch: 31,
              },
              {
                cm: 81.5,
                inch: 32,
              },
            ],
          },
        ],
      },
      {
        header: ['Women Sizes', 'S', 'M', 'L', 'XL', 'XXL'],
        rows: [
          {
            label: 'Chest Size',
            values: [
              {
                cm: 41,
                inch: 16,
              },
              {
                cm: 43,
                inch: 17,
              },
              {
                cm: 47,
                inch: 18.5,
              },
              {
                cm: 50,
                inch: 19.5,
              },
              {
                cm: 56,
                inch: 22,
              },
            ],
          },
          {
            label: 'Length',
            values: [
              {
                cm: 64,
                inch: 25.25,
              },
              {
                cm: 67,
                inch: 26.25,
              },
              {
                cm: 69,
                inch: 27.25,
              },
              {
                cm: 71,
                inch: 28,
              },
              {
                cm: 72,
                inch: 28.5,
              },
            ],
          },
        ],
      },
    ],
  },
];

export default sizeChartData;
